import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SETTINGS } from '../configs/common.settings';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class GooglePlaceApiService {
  placeFetchingInfo = new BehaviorSubject({});

  constructor(private http: HttpClient) {}

  getPlacePredictions(input: string): Observable<any> {
    return this.http.get(
      `${SETTINGS.BASE_API}/google-map/predictions/${input}`
    );
  }

  getPlaceById(id: string): Observable<any> {
    return this.http.get(`${SETTINGS.BASE_API}/google-map/place/${id}`);
  }
}
